import React from 'react'
import SEO from "../common/SEO";
import Footer from '../common/footer/_Footer';
import Separator from "../elements/separator/Separator";
import TopBar from '../common/header/_TopBar';
import Header from '../common/header/_Header';
import PhotoThanks from '../common/PhotoThanks';
import BoxMetodo from '../elements/_BoxMetodo';
import BoxRealizzazioni from '../elements/_BoxRealizzazioni';
import BoxSoftware from '../elements/_BoxSoftware';
import BoxFaq from '../elements/_BoxFaq';
import GATracker from '../gaTracker';

const SviluppoSoftware = () => {

    GATracker();

    return (
        <>
            <SEO title="Sviluppo software personalizzato" description={"Sviluppo software personalizzato"} />
            <main className="page-wrapper">
                
            <TopBar />
            <Header btnStyle="btn-small btn-icon" HeaderSTyle="header-not-transparent" />

                {/* Start Slider Area  */}
                <div className="slider-area slider-style-1 height-550 bg_image" data-black-overlay="7" style={{backgroundImage: `url(${process.env.PUBLIC_URL}/images/bg/bg-software.jpg)`}}>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="inner pt--80 text-center">
                                    <h1 className="title display-one">Sviluppo Software<br/>Personalizzato</h1>
                                </div>
                            </div>
                        </div>                        
                    </div>                    
                </div>  
                <PhotoThanks name="Shahadat Rahman" link="hishahadat" />  
                {/* End Slider Area  */}

                <Separator />

                <BoxSoftware />
     
                <Separator />

                <BoxMetodo />

                <Separator />

                <BoxFaq />

                <Separator />

                <BoxRealizzazioni />

                <Footer />

            </main>
        </>
    )
}

export default SviluppoSoftware;
